module.exports = __webpack_public_path__ + "img/medium.dc03779b.png";